var map = {
	"./app-store-badge-downloads.svg": "341e",
	"./flat-foot-shoe.svg": "b5d9",
	"./flat-foot.svg": "c4d6",
	"./forefoot_strike.svg": "44eb",
	"./google-play-badge-downloads.svg": "ece3",
	"./heel-off-shoe.svg": "44d0",
	"./heel-strike-shoe.svg": "9115",
	"./heel-strike.svg": "8673",
	"./little-symmetry-bad.svg": "47e1",
	"./little-symmetry-good.svg": "49d1",
	"./little-symmetry-neutral.svg": "dcc3",
	"./little-symmetry-warning.svg": "fc06",
	"./logo.svg": "e347",
	"./midfoot_strike.svg": "8b7f",
	"./patho-F.svg": "9dd7",
	"./patho-H.svg": "97d3",
	"./patho-unknown-F.svg": "1987",
	"./patho-unknown-H.svg": "51cd",
	"./plus-or-minus.svg": "477d",
	"./propulsion.svg": "99d7",
	"./rearfoot_strike.svg": "b5cf",
	"./rehab-icon.svg": "7061",
	"./running-module.svg": "4f75",
	"./running-profile.svg": "542f",
	"./single-shoe.svg": "e679",
	"./symmetry-bad.svg": "3dfb",
	"./symmetry-good.svg": "6523",
	"./symmetry-neutral.svg": "f5ea",
	"./symmetry-warning.svg": "9306",
	"./toe-off-shoe.svg": "9cf5",
	"./toe-strike-shoe.svg": "4098",
	"./walking-phase.svg": "f4a7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f57b";